import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
        <Logo className="mb-6" />
        {sent ? (
          <div className="text-center py-6" data-testid="forgot-sent">
            <div className="w-14 h-14 rounded-full bg-emerald-50 grid place-items-center mx-auto mb-4"><MailCheck className="w-7 h-7 text-emerald-600" /></div>
            <h1 className="font-heading text-2xl font-bold">Vérifiez vos emails</h1>
            <p className="mt-2 text-slate-500">Si un compte existe pour <b>{email}</b>, un lien de réinitialisation vient d'être envoyé.</p>
            <Link to="/login"><Button variant="outline" className="mt-6 rounded-xl">Retour à la connexion</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-bold">Mot de passe oublié</h1>
            <p className="mt-2 text-slate-500">Entrez votre email pour recevoir un lien de réinitialisation.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" className="mt-1.5 h-11" />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full h-11 bg-blue-600 hover:bg-blue-700 rounded-xl">
                {loading ? "Envoi..." : "Envoyer le lien"}
              </Button>
            </form>
            <p className="mt-6 text-sm text-slate-500 text-center"><Link to="/login" className="text-blue-600 hover:underline">Retour à la connexion</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
